import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";

export function matchesLicensePlateScan(
  item: { inventoryItemId?: string | null },
  scannedBarcode: string,
): boolean {
  if (!item.inventoryItemId) {
    return false;
  }
  const expectedRawId = decodeLicensePlateId(item.inventoryItemId);
  const scannedRawId = normalizeLicensePlateScan(scannedBarcode);
  return expectedRawId !== null && expectedRawId === scannedRawId;
}

export function buildLicensePlateScanSet(
  formattedIds: Iterable<string | null | undefined>,
): Set<string> {
  const result = new Set<string>();
  for (const formatted of formattedIds) {
    if (!formatted) {
      continue;
    }
    const raw = decodeLicensePlateId(formatted);
    if (raw !== null) {
      result.add(raw);
    }
  }
  return result;
}

export function normalizeLicensePlateScan(value: string): string | null {
  if (!value) {
    return null;
  }
  if (value.startsWith("ii_")) {
    return decodeLicensePlateId(value);
  }
  if (/^\d+$/.test(value)) {
    return value;
  }
  return null;
}

/** Groups a raw id's digits in fours, as printed under the license plate QR. */
export function formatLicensePlate(value: string): string {
  if (!/^\d+$/.test(value)) {
    return value;
  }
  const chunks: string[] = [];
  for (let i = 0; i < value.length; i += 4) {
    chunks.push(value.slice(i, i + 4));
  }
  return chunks.join(" ");
}

export function decodeLicensePlateId(formatted: string): string | null {
  if (!inventoryItemIdFormat.test(formatted)) {
    return null;
  }
  try {
    return inventoryItemIdFormat.read(formatted).toString();
  } catch {
    return null;
  }
}
